//import $store from '../store';
/* import $router from '../router'; *///no incluir o se rompen las rutas
import {
	ENDPOINT_TOKEN_REFRESH,
	ENDPOINT_TOKEN_REFRESH_USER,
} from '../config';
import { enc, dec } from '../functions/general.js';
import axios from 'axios';
require('es6-promise').polyfill();
require('isomorphic-fetch');
const res_r_status = async (a,c={})=>(c['r_s_'+a.status]=await a.json())&& c;

const bs = function($store){ 
	const responseType = 'arraybuffer';
	var FileSaver = require('file-saver');

	const get_rq = (name) => $store.getters.requestStatus.find(f => f.name === name);
	const setRequestStatus = (name, status) => {
		const rs = get_rq(name);
		if (!rs) return false;
		rs.status = status;
		if (['success', 'error'].includes(status)) {
			rs.ticking = true;
			status === 'success'
				? setTimeout(() => rs.ticking = false, 3000)
				: setTimeout(() => rs.ticking = false, 6000);
		}
		return rs;
	};

	const reset_rq_status = (name) =>{
		const rs = get_rq(name);
		if (!rs) return false;
		rs.status = false;
		rs.ticking = false;
	}
	
	const reset_rq_status_all = (list=[]) => list.forEach(
		n => reset_rq_status(n) || ((get_rq(n)||{}).names||[]).forEach(nn=>reset_rq_status(`${nn}-${n}`))
	);

	const maybeRefreshMyManagementPending = (key, result) => {
		if (key && key.refresh_my_management_pending) {
			$store.dispatch('refreshMyManagementPendingViews');
		}
		return result;
	};

	const headers = () => {
		return {
			'Content-Type': 'application/json',
			Accept: 'application/json',
			Authorization: `Bearer ${is_null_token() && (/* 'U2FsdGVkX19DVxbyl334z1Hv/iP0mDzSgFR+JT85y7zm1IvBa6YM63bjbgQoEcrrKGHPX3la/bQap04bKorrYfpPfGsb7SR37EP3NAQ5WFTt+OXUjjxw/fVaCa2EwAR2D1UpndSBMk0VKLiaGttzdALAH0gf2pjOeblo5gdu2BAZFAVX61R5iH4/5odMNvpMdi+RVF9NQufWs8fU+lNlV+wxRHPVeI+e6z4Y2tzivIgXO/+JlLgtztKJ3P1F+Rb4jXlz4+HCm2Tf8/rmy+TVl+d4hUtp2OsAFjVryeUiQdyWqGGto0edGj/bkWYaHxpXMq31qnV8JEXy17+N//W+Xg==' || */ $store.getters.access.val || $store.getters.session.access)/* quitar cuando ya nose use */}`
		}
	};
	const Authorization = () => `Bearer ${is_null_token() && (/* 'U2FsdGVkX19DVxbyl334z1Hv/iP0mDzSgFR+JT85y7zm1IvBa6YM63bjbgQoEcrrKGHPX3la/bQap04bKorrYfpPfGsb7SR37EP3NAQ5WFTt+OXUjjxw/fVaCa2EwAR2D1UpndSBMk0VKLiaGttzdALAH0gf2pjOeblo5gdu2BAZFAVX61R5iH4/5odMNvpMdi+RVF9NQufWs8fU+lNlV+wxRHPVeI+e6z4Y2tzivIgXO/+JlLgtztKJ3P1F+Rb4jXlz4+HCm2Tf8/rmy+TVl+d4hUtp2OsAFjVryeUiQdyWqGGto0edGj/bkWYaHxpXMq31qnV8JEXy17+N//W+Xg==' || */ $store.getters.access.val || $store.getters.session.access)/* quitar cuando ya nose use */}`

	const PUT = (obj) => {
		return{
			method: 'PUT',
			headers: headers(),
			body: JSON.stringify(obj)
		}
	};

	const PATCH = (obj) => {
		return{
			method: 'PATCH',
			headers: headers(),
			body: JSON.stringify(obj)
		}
	};

	const PATCH_M = (obj) => {
		const formData = new FormData();
		
		Object.keys(obj).forEach(k => {
			formData.append(k,obj[k])
		});
		return{
			method: 'PATCH',
			headers : { 
				Authorization: Authorization(),
				Accept: 'application/json'
			},
			body: formData
		}
	};
	const PUTmulti = (obj) => {
		const formData = new FormData();
		
		Object.keys(obj).forEach(k => {
			formData.append(k,obj[k])
		});
		return{
			method: 'PUT',
			headers : { 
				Authorization: Authorization(),
				Accept: 'application/json'
			},
			body: formData
		}
	};

	function getFormData(formData, data, previousKey) {
		if (data instanceof Object) {
		Object.keys(data).forEach(key => {
			const value = data[key];
			if (value instanceof Object && !Array.isArray(value) && !(value instanceof File)) {
				console.log({key});//instanceof File
			return getFormData(formData, value, key);
			}
			if (previousKey) {
			key = `${previousKey}[${key}]`;
			}
			if (Array.isArray(value)) {
			value.forEach(val => {
				formData.append(`${key}[]`, val);
			});
			} else {
			formData.append(key, value);
			}
		});
		}
	};
	const POSTmulti =  (obj) => {
		const formData = new FormData();
		getFormData(formData, obj)
		return{
			method: 'POST',
			headers : {
				Authorization: Authorization(),
				Accept: 'application/json'
			},
			body:  formData
		}
	};

	const POST = (obj) => {
		return{
			method: 'POST',
			headers: headers(),
			body: JSON.stringify(obj)
		}
	};

	const GET = () => {
		return { method: 'GET', headers: headers() }
	};

	const DELETE = () => {
		return{
			method: 'DELETE',
			headers: headers(),
		}
	};

	const success_status = [200,201];
	const vld = (r, key) => success_status.includes(r.status) ? setRequestStatus(key,'success') && r.json() : setRequestStatus(key,'error') && undefined;
	const valid_res = (r) => success_status.includes(r.status)? r: (r.status == 401? logout(): throw_response_error(r.status));
	const throw_response_error = (st) => {throw new Error(`respuesta insatifactoria, codigo:${st}`)};

	const serializeFilterValue = (value) => {
		if (Array.isArray(value)) return `[${value.join(',')}]`;
		if (value && typeof value === 'object') return JSON.stringify(value);
		return value;
	};

	const setFilters = (filters) => {
		if (!filters) return '';
		const array = Object.keys(filters).map(k => {
			const key = encodeURIComponent(k);
			const value = encodeURIComponent(serializeFilterValue(filters[k]));
			return `${key}=${value}`;
		});
		return array.length ? `?${array.join('&')}` : '';
	}

	/* hay q tenerlo en guardado, pq sino  el codigo viejo puede pasar a  borrarlo por 1sec*/
	const is_null_token = () => {
		if ($store.getters.null_token === true) {
			$store.dispatch('set',{key:'null_token', val:false});
			return false;
		}
		return true
	}
	const getRefresh = () => $store.getters.session.refresh || dec(localStorage.getItem('AS2X'));
	const login = (obj) => !localStorage.getItem('AS2X') && localStorage.setItem('AS2X', enc(obj));

	const logout = () => {
		$store.dispatch('logout')
		/* $router.push({name:'login'}); */
		//por si queda alguna basura, porsiacaso, reload deberia dejar la pagina como si recien entrara
		//location.reload();
		//anque al recargar deberia interrumpir la ejcucion de lo siguiente
		return false;
	}
	//watch la la promesa en de acces, si tiene respuesta vacia, logout
	const getAccessAndUser = async () =>
		getRefresh() &&
		fetch(ENDPOINT_TOKEN_REFRESH_USER, POST({refresh: getRefresh()}))
			.then(res => res.json())
			.catch(e => console.error('Error verificar token',e));

	const getAccess = async () =>
		getRefresh() &&
		fetch(ENDPOINT_TOKEN_REFRESH, POST({refresh: getRefresh()}))
		//.then(res => console.log('ok',{res}) || res)
			.then(res => res.json())
			.catch(e => console.error('Error verificar token',e));

	const sendMailSoporte = (session, form) => {

		const {token} = session;
		/* const url = `${ENDPOINT_INVENTORY}/usuarios/mailing/soporte`;
		return axios.post(url, { form }, { headers: { Authorization: `Bearer ${token}` } }) */
	}

	
	function resolveAfter(x,t) { 
		return new Promise(resolve => {
			setTimeout(() => {
			resolve(x);
			}, t);
		});
	};

	const await_for_access = async(await_count=0) => {
		if (await_count > 10) return console.warn({await_count} ,'> 10') || false;
		const {access} = $store.getters;
		if (access.status === 1) return true;
		console.log('Espere?');
		await_count++;
		return await resolveAfter(()=>await_for_access(await_count), 1000);
	};

	const tkn_exp = 240000;
	const assignAccess = async() => {
		const time = new Date().getTime();
		const p_time = $store.getters.access.time;

		if (time>(p_time+tkn_exp)) {
			$store.dispatch('assign',{key:'access', val:{time,status:0,val:null}});
			try {
				//console.log('get access ini');
				$store.dispatch('assign',{key:'access', val:{val:(await getAccess() || {}).access}});	
				//console.log('get access fin');
			} catch (e) {
				$store.dispatch('assign',{key:'access', val:{time,status:0,val:null}});
				console.error('no se pudo obtener token',{e})	
			}
			$store.dispatch('assign',{key:'access', val:{status:1}});
		}
		if (await await_for_access()) {
			return true
		} else {
			console.error('no se pudo obtener token')
			return false
		} // if
	}

	const once_rqs = {};
	const getENDPOINT = (e) => e.lpath || `${e.b}/${e.altp || e.rp}/`;

	const pre_req = async(req, args={}) => {
		let ENDPOINT;
		if (args.once) {
			ENDPOINT = getENDPOINT(args);
			if (once_rqs[ENDPOINT]) return once_rqs[ENDPOINT];
		} // if
	//console.log('----');
		const res_acc = await assignAccess();
		//console.log({res_acc});
		if (!res_acc){
			$store.dispatch('setProgress',{show:false});
			$store.dispatch('setSnackbar',{message:'No se pudo obtener acceso',class:'error'});
			return 
		} // if
		const reqP = req();
		if (args.once) {
			once_rqs[ENDPOINT] = reqP;
			reqP.then(r => r || delete once_rqs[ENDPOINT]);
		} // if
		return reqP;
	} // pre_req


	const put_no_id = (ENDPOINT, key) => (obj, filters) => pre_req(()=>fetch(
		ENDPOINT + setFilters(filters || {}),
		PUT(obj))
		.then(res => res.json())
		.then(r => maybeRefreshMyManagementPending(key, r)));

	const put = (ENDPOINT,key) => (obj) => pre_req(()=>{
		reset_rq_status_all(key.reset_rq_rp);
		return fetch(
		`${ENDPOINT}${obj.id}/`,
		PUT(obj))
		.then(res => res.json())
	});

	const patch = (ENDPOINT,key) => (obj) => pre_req(()=>{
		reset_rq_status_all(key.reset_rq_rp);
		return fetch(
			ENDPOINT + (obj.id? `${obj.id}/`: ''),
			PATCH(obj))
			.then(res => {
				if (res.status === 400) return res_r_status(res);
				return res.json().then(r => maybeRefreshMyManagementPending(key, r));
			})
	});

	const patch_restore = (ENDPOINT,key) => (obj) => pre_req(()=>{
		reset_rq_status_all(key.reset_rq_rp);
		return fetch(
			ENDPOINT + `${obj.id}/restore/`,
			PATCH(obj))
			.then(res => res.json())
	});
	
	const patch_m = (ENDPOINT,key) => (obj) => pre_req(()=>{
		reset_rq_status_all(key.reset_rq_rp);
		return fetch(
		ENDPOINT + obj.id + '/',
		PATCH_M(obj))
		.then(res => res.json())
	});

	const get = (ENDPOINT,args) => (id, filters) => pre_req(()=>{
		let params = id ? `${id}/` : '';
		params += setFilters(filters || {});
		
		return fetch(ENDPOINT + params, GET())
			.then(r => args.disable_check_res ? r : valid_res(r))
			.then(res => res.json())
			.catch(e => console.error(e) || Promise.reject(`cadena de consulta ${ENDPOINT} terminada debido a un error`));
	},args)

	const deleteRq = (ENDPOINT) => (id, filters) => pre_req(()=>{
		let params = id ? `${id}/` : '';
		params += setFilters(filters || {});
		return fetch(ENDPOINT + params, DELETE())
		.then(res => console.log({res}) || res)
			.then(res => res/* .json() */);
	})

	const gets = (ENDPOINT, key) =>
	(filters) =>
	pre_req(
			()=> {
				//console.log({key}, setFilters(filters),{filters});
				const rs = $store.getters.requestStatus.find(f => f.name === key);
				// no consulta si la info esta
				if (!rs) console.error('! No se ha definido requestStatus de ', key);
				// status 2 es cuando se filtra, para evitar que cuando se detecte un cambio en la request las otras tambien hagan peticiones y usar la misma
				if (![false, 'error',2].includes(rs.status)) return rs.rq;//aqui retorna la misma promesa para todas las consunltas sincronizadas
				setRequestStatus(key,'getting')
				rs.rq = fetch(ENDPOINT + setFilters(filters), GET())
					.then(r => {
						if (rs.disable_check_res) return r;
						const res = vld(r, key);
						if (r.status == 401) logout();
						return rs.status == 'error'? throw_response_error(r.status): res;
					})
					.catch(e => {
						setRequestStatus(key,'error');
						console.error(e);
						Promise.reject(`cadena de consulta ${ENDPOINT} terminada debido a un error`);
					});
				return rs.rq;
			}
		);
	const getsSimple = (ENDPOINT,args) => (filters) => pre_req(()=>{
		return fetch(ENDPOINT + setFilters(filters), GET())
			.then(r => args.disable_check_res ? r : valid_res(r))
			.then(r => r.json())
			.catch(e => console.error(e) || Promise.reject(`cadena de consulta ${ENDPOINT} terminada debido a un error`));
	},args)

	const get_export = (ENDPOINT) => (filters) => pre_req(() => {
		$store.dispatch('setProgress',{show:true,message:'Cargando...'})
		return axios.get(ENDPOINT + setFilters(filters), {responseType, headers: { Authorization: Authorization() }})
			.then(d => d.data)
			.then(async res => {
				$store.dispatch('setProgress',{show:false});
				const blob = new Blob([new Uint8Array(res)], {encoding:"UTF8", type: 'charset=UTF8;',charset: 'utf8' });
				FileSaver.saveAs(blob, 'Reporte.xlsx');
				return res;
			});
	})
	// --------------ADD----------------------------------------------
	const post = (ENDPOINT,key) => (obj,extra='') => pre_req(()=>{
		reset_rq_status_all(key.reset_rq_rp);
		return fetch(
		ENDPOINT + extra,
		POST(obj))
		.then(res => res.status===400 ? res_r_status(res):res.json())
	});

	const post_m = (ENDPOINT,key) => (obj,extra='') => pre_req(()=>{
		reset_rq_status_all(key.reset_rq_rp);
		return fetch(
		ENDPOINT + extra,
		POSTmulti(obj))
		.then(res => res.json())
	});



		
	this.getRefresh = getRefresh;
	this.login = login;
	this.getAccessAndUser = getAccessAndUser;
	this.getAccess = getAccess;
	this.sendMailSoporte = sendMailSoporte;
	this.assignAccess = assignAccess;
	this.put_no_id = put_no_id;
	this.put = put;
	this.patch = patch;
	this.patch_m = patch_m;
	this.get = get;
	this.deleteRq = deleteRq;
	this.gets = gets;
	this.getsSimple = getsSimple;
	this.get_export = get_export;
	this.post = post;
	this.post_m = post_m;
	this.patch_restore = patch_restore;
	$store.dispatch('set', {key: 'bs', val: this});
}
export default bs;